module.exports = __webpack_public_path__ + "static/assets/google-icon-small.1b943d7.png";